<template>
  <div>
    <div class="text-left mb-5">
      <span class="headline" id="headerlist">Raw Materials List</span>
    </div>
    <!-- Table Start -->
    <div class="holder">
      <div class="filter">
        <v-text-field
          v-model="filter"
          v-on:keyup="filterList"
          label="search by raw material name"
          append-icon="mdi-filter"
        />
      </div>
      <div class="paginate">
        <v-select
          v-model="paginationcount"
          v-on:change="paginateList"
          :items="paginationcounts"
          item-text="name"
          item-value="name"
          :selected="paginationcounts.value === 10"
          label="show by"
        ></v-select>
      </div>
    </div>
    <v-simple-table fixed-header fixed-footer height="450px" class="elevation-2">
      <template v-slot:default>
        <thead>
          <tr class="tableheader">
            <th class="text-left">Name</th>
            <th class="text-left">Cost</th>
            <th class="text-left">Unit</th>
            <th class="text-left">Supplier</th>
            <th class="text-left">Total Quantity In-stock</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in rawMaterials" :key="item.id" @click="showRawMaterial(item.id)">
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">{{ parseFloat(item.cost).toLocaleString() }}</td>
            <td class="text-left">{{ item.unit_type }}</td>
            <td class="text-left">{{ item.supplier.company_name }}</td>
            <td class="text-left">{{ parseFloat(item.totalinstock).toLocaleString() }}</td>
          </tr>
          <tr v-if="pagination.meta.total == 0">
            <td colspan="5" style="height:400px; text-align: center;">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="pt-2">
      <v-pagination
        v-if="pagination.meta.total > 0"
        align="right"
        v-model="page"
        :length="pagination.meta.last_page"
        circle
      ></v-pagination>
    </div>
    <!-- Table End -->
    <!-- Create Start -->
    <v-btn
      fixed
      bottom
      right
      @click="$router.push('/rawmaterial/create')"
      color="blue darken-2"
      dark
      fab
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <rawMaterialCreate
      v-if="create"
      :page="page"
      :create="create"
      @createChange="
        value => {
          this.create = value;
        }
      "
    />
    <rawMaterialEdit v-if="edit" :page="page" :edit="edit" />
    <rawMaterialShow
      v-if="show"
      :show="show"
      :page="page"
      :joborder="joborder"
      :quantity="quantity"
    />
    <rawMaterialInventory v-if="inventory" :page="page" :inventory="inventory" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import rawMaterialCreate from './RawMaterialCreate';
import rawMaterialEdit from './RawMaterialEdit';
import rawMaterialShow from './RawMaterialShow';
import rawMaterialInventory from './RawMaterialInventory';

export default {
  data: function() {
    return {
      page: 1,
      filter: '',
      paginationcount: '10'
    };
  },
  components: {
    rawMaterialCreate,
    rawMaterialEdit,
    rawMaterialShow,
    rawMaterialInventory
  },
  props: {
    create: false,
    show: false,
    edit: false,
    joborder: true,
    quantity: true,
    inventory: false
  },
  watch: {
    page(val) {
      this['RawMaterial/fetchRawMaterials']({
        page: val,
        filter: this.filter,
        paginationcount: this.paginationcount
      });
    },
    $route(to, from) {
      if (this.show) {
        this['RawMaterial/getRawMaterial']({ id: to.params.id });
      }
    }
  },
  computed: {
    ...mapState({
      rawMaterials: state => state.RawMaterial.rawMaterials.data,
      paginationcounts: state => state.Unit.paginationcount,
      pagination: state => {
        if (state.RawMaterial.rawMaterials.length === 0) {
          return {
            meta: {
              last_page: 0
            }
          };
        }
        let ctr = 0;
        state.RawMaterial.rawMaterials.data.forEach(item => {
          let count = 0;
          let i = 0;
          let totalinstock = 0;
          let totalquantity = 0;

          for (i = 0; i < item.job_order_materials.length; i++) {
            if (item.job_order_materials[i].pivot.quantity !== 'undefined') {
              count += parseFloat(item.job_order_materials[i].pivot.quantity);
            }
          }

          let itemcount = 0;
          let k = 0;
          if (item.raw_material_inventories.length > 0) {
            for (k = 0; k < item.raw_material_inventories.length; k++) {
              if (item.raw_material_inventories[k].pivot.quantity !== 'undefined') {
                itemcount += parseFloat(item.raw_material_inventories[k].pivot.quantity);
              }
            }
          }

          totalquantity = parseFloat(itemcount);
          totalinstock = parseFloat(itemcount) - parseFloat(count);
          state.RawMaterial.rawMaterials.data[ctr].totalinstock = totalinstock;
          state.RawMaterial.rawMaterials.data[ctr].totalquantity = totalquantity;
          ctr++;
        });

        return state.RawMaterial.rawMaterials;
      }
    })
  },
  mounted() {
    this['RawMaterial/fetchRawMaterials']({
      page: this.page,
      paginationcount: this.paginationcount
    });
  },
  methods: {
    ...mapActions(['RawMaterial/fetchRawMaterials', 'RawMaterial/getRawMaterial']),
    showRawMaterial(id) {
      this.$router.push(`/rawmaterial/${id}`);
    },
    filterList() {
      if (this.page !== 1) this.page = 1;
      else
        this['RawMaterial/fetchRawMaterials']({
          page: this.page,
          filter: this.filter,
          paginationcount: this.paginationcount
        });
    },
    paginateList() {
      if (this.page !== 1) this.page = 1;
      else
        this['RawMaterial/fetchRawMaterials']({ page: 1, paginationcount: this.paginationcount });
    }
  }
};
</script>
